/**
 * @module cercaliagl/control/Control
 */
import { createUid, isMobile } from '../util';
import { getDOMRelativePosition } from '../view/VUtils';
/**
 * @classdesc
 * Cercalia Control base class.
 * @api
 */
var Control = /** @class */ (function () {
    /**
     * @constructor
     * @param {Object} options Options
     */
    function Control(options) {
        /**
         * @private
         * @type {import("maplibre-gl").Map}
         */
        this.map_ = null;
        /**
         * @protected
         * @type {import('./ViewInterface').default}
         */
        this.viewInterface_ = null;
        /**
         * @protected
         * @type {string}
         */
        this.name_ = options.name !== undefined ? options.name : null;
        /**
         * @protected
         * @type {string}
         */
        this.className_ = options.className !== undefined ? options.className : 'cercalia.control.Control';
        /**
         * @protected
         * @type {string}
         */
        this.id_ = "".concat(this.className_, "_").concat(createUid());
        /**
         * @protected
         * @type {Element}
         */
        this.element_ = options.element;
        /**
         * @protected
         * @type {Element|null}
         */
        this.dialogElement_ = options.dialog !== undefined ? options.dialog : null;
    }
    Control.prototype.onAdd = function (map) {
        this.map_ = map;
        return this.element_;
    };
    /**
     * Get control id.
     * @api
     * @return {string} Id.
     */
    Control.prototype.getId = function () {
        return this.id_;
    };
    /**
     * Get class name.
     * @api
     * @return {string} Class name.
     */
    Control.prototype.getClass = function () {
        return this.className_;
    };
    /**
     * Get control name. Null if control has not defined name.
     * @api
     * @return {string|null} Class name.
     */
    Control.prototype.getName = function () {
        return this.name_;
    };
    /**
     * Get control HTML Element
     * @api
     * @return {Element} HTML Element
     */
    Control.prototype.getElement = function () {
        return this.element_;
    };
    /**
     * Returns `cercalia` Map object
     * @return {import('../Map').default} Cercalia map.
     * @api
     */
    Control.prototype.getCercaliaMap = function () {
        return this.map_.getCercaliaMap();
    };
    /**
     * Returns `mapboxgl` Map object
     * @return {import('maplibre-gl').Map}
     * @api
     */
    Control.prototype.getMap = function () {
        return this.map_;
    };
    /**
     * @param {import('./ViewInterface').default} viewInterface Interface control.
     */
    Control.prototype.setViewInterface = function (viewInterface) {
        this.viewInterface_ = viewInterface;
    };
    /**
     * @return {import('./ViewInterface').default} Interface
     */
    Control.prototype.getViewInterface = function () {
        return this.viewInterface_;
    };
    /**
     * Hide control.
     * @api
     */
    Control.prototype.hide = function () {
        // this.element_.hidden = true;
        this.element_.classList.add('hidden');
    };
    /**
     * Show control.
     * @api
     */
    Control.prototype.show = function () {
        // this.element_.hidden = false;
        this.element_.classList.remove('hidden');
    };
    /**
     * @param {Element|null} dialogElement Element
     */
    Control.prototype.setDialog = function (dialogElement) {
        this.dialogElement_ = dialogElement;
    };
    /**
     * @return {Element|null} DialogElement
     */
    Control.prototype.getDialog = function () {
        return this.dialogElement_;
    };
    /**
     * @protected
     */
    Control.prototype.adjustPosition_ = function (dropdown) {
        var parentContainer = this.getMap().getContainer();
        var relativePos = getDOMRelativePosition(this.element_, parentContainer);
        var htmlElement = dropdown.getElement();
        // Eliminar els estils, excepte display, per evitar que htmlElement.offsetWidth sigui 0 en dispositius mòbils
        var display = htmlElement.style.display;
        htmlElement.removeAttribute('style');
        if (isMobile()) {
            var parentWidth = parentContainer.offsetWidth;
            var htmlElementWidth = htmlElement.offsetWidth;
            var htmlElementRight = Math.abs(relativePos.right);
            if (htmlElementWidth + htmlElementRight > parentWidth) {
                htmlElement.style.left = '4px';
                htmlElement.style.right = 'auto';
            }
            else {
                htmlElement.style.right = "".concat(htmlElementRight + 4, "px");
            }
            htmlElement.style.top = '';
            htmlElement.style.bottom = "".concat(Math.abs(relativePos.bottom) + 42, "px");
        }
        else {
            htmlElement.style.top = "".concat(relativePos.top + this.element_.offsetHeight + 4, "px");
            htmlElement.style.right = "".concat(Math.abs(relativePos.right), "px");
            htmlElement.style.bottom = '';
        }
        htmlElement.style.display = display;
    };
    return Control;
}());
export default Control;
//# sourceMappingURL=Control.js.map